import { render, staticRenderFns } from "./geo_referencing.vue?vue&type=template&id=6549f644"
import script from "./geo_referencing.vue?vue&type=script&lang=js"
export * from "./geo_referencing.vue?vue&type=script&lang=js"
import style0 from "./geo_referencing.vue?vue&type=style&index=0&id=6549f644&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports